import React from 'react';
import { Box, Hint, Inscription, RawButton } from '@common-fe/common-fe';

import { HintTrigger } from './UnappliedFundsBanner.styles';

interface Props {
  title: string;
  organizationNames: string[];
  organizationsCount: number;
  onViewAll: () => void;
  testId: string;
}

const HINT_WIDTH = 250;
const HINT_HEIGHT = 200;
const LIST_MAX_HEIGHT = '176px';

const UnappliedFundsOrganizationsHint: React.FC<Props> = ({
  title,
  organizationNames,
  organizationsCount,
  onViewAll,
  testId,
}) => (
  <Hint
    testId={testId}
    hintWidth={HINT_WIDTH}
    hintHeight={HINT_HEIGHT}
    hintElement={<HintTrigger data-testid={`${testId}_trigger`}>{title}</HintTrigger>}
  >
    <Box data-testid={`${testId}_list`} overflow={{ vertical: 'auto' }} height={{ max: LIST_MAX_HEIGHT }}>
      {organizationNames.map((name, index) => (
        <Inscription
          key={`${index}_${name}`}
          size="small"
          weight={500}
          color="textOnColor"
          lineHeight="18px"
          data-testid={`${testId}_organization_${index}`}
        >
          {index + 1}. {name}
        </Inscription>
      ))}
      {organizationsCount > organizationNames.length && (
        <>
          <Inscription size="small" weight={500} color="textOnColor" lineHeight="18px" data-testid={`${testId}_more`}>
            …
          </Inscription>
          <RawButton onClick={onViewAll} data-testid={`${testId}_view-all`}>
            <Inscription weight={400} color="buttonPrimary" lineHeight="20px">
              View All {organizationsCount} Organizations
            </Inscription>
          </RawButton>
        </>
      )}
    </Box>
  </Hint>
);

export default UnappliedFundsOrganizationsHint;
